"use strict";

/**
 * 字符串截取
 * @param str
 * @param length
 * @returns {string}
 */
module.exports = function (str, length) {
  if (!str) return "";
  return str.length <= length ? str : str.substr(0, length - 1) + '...';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ty-vue-filters@1.0.22@ty-vue-filters/dist/filters/mbSubstr.js
// module id = eD6N
// module chunks = 300